import { URL } from '@ux/util';

function getCurrentHref(currentHref, isBrowser, location) {
  //
  // Logic originally from
  // https://github.secureserver.net/UX/product-nav/blob/119ebd4ffc55e41a4bfebe1c973f55de0c3e35bc/lib/product-nav.js#L37
  //
  if (isBrowser) {
    currentHref = location;
  }

  if (currentHref) {
    const currentUrl = new URL(currentHref, true);
    const qsCurrentHref = currentUrl.query.currentPage;
    if (qsCurrentHref) {
      currentHref = qsCurrentHref;
    } else {
      // Remove query string for comparisons
      currentUrl.set('query', {});
      currentHref = currentUrl.href;
    }
  }

  return currentHref;
}

export {
  getCurrentHref
};

